import { render, staticRenderFns } from "./ProductCategoryList.vue?vue&type=template&id=82f0f7d4&scoped=true"
import script from "./ProductCategoryList.vue?vue&type=script&lang=js"
export * from "./ProductCategoryList.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryList.vue?vue&type=style&index=0&id=82f0f7d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f0f7d4",
  null
  
)

export default component.exports